export enum CoinBackSteps {
  CLOSED = -1,
  CHECK_FEATURE = 0,
  HOW_TO_EARN_POINTS = 1,
  TOTAL_BALANCE = 2,
  BALANCE_AVAILABLE = 3,
  BALANCE_LOCKED = 4,
  REWARDS_CHECK_BALANCE = 5,
  CLAIM_KEEP_COINBACK = 6,
  CLAIM_KEEP_COINBACK_DONE = 7,
}
export const COIN_BACK_DATA_TEST_ID = 'coinback';

export const COIN_BACK_TUTORIAL_DATA_TEST_ID = `${COIN_BACK_DATA_TEST_ID}-tutorial`;
